import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    searchTerm: null,
};

const filterSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        addFilterSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
    },
});

export const { addFilterSearchTerm } = filterSlice.actions;
export default filterSlice.reducer;
